export default __webpack_public_path__ + "static/media/history.f4c3d469.svg";